import React from 'react';
import { useQueryClient } from 'react-query';
import { Select } from 'antd';
import FormRow from '../../../common/formComponents/FormRow/FormRow';
import FormItem from '../../../common/formComponents/FormItem/FormItem';
import useHousingStockMatch from '../../../../hooks/useHousingStockMatch';
import { getQueryKeys } from '../../../../queries/queryKeys';

const { Option } = Select;

const SelectFlat = ({ form }) => {
  const match = useHousingStockMatch();

  const queryClient = useQueryClient();

  const flats = queryClient.getQueryData(
    getQueryKeys.flatsGrid(Number(match?.params.pageId))
  );

  return (
    <FormRow>
      <FormItem label="Выберите квартиру">
        {form.getFieldDecorator('flatData', {
          rules: [{ required: true, message: 'Укажите номер квартиры' }],
        })(
          <Select
            showSearch
            labelInValue
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children
                .replace('.', '')
                .toLowerCase()
                .indexOf(input.replace('.', '').toLowerCase()) >= 0
            }
          >
            {flats.map((flat) => (
              <Option
                value={flat.addressId}
                key={flat.addressId}
              >{`кв. ${flat.flat}`}</Option>
            ))}
          </Select>
        )}
      </FormItem>
    </FormRow>
  );
};

export default SelectFlat;
